var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    directives: [
      {
        name: "mask",
        rawName: "v-mask",
        value: "##/##/####",
        expression: "'##/##/####'",
      },
      {
        name: "model",
        rawName: "v-model",
        value: _vm.dateModel,
        expression: "dateModel",
      },
    ],
    staticClass: "emd-input",
    attrs: { id: _vm.id, type: "tel", placeholder: _vm.$t("placeholder") },
    domProps: { value: _vm.dateModel },
    on: {
      input: function ($event) {
        if ($event.target.composing) return
        _vm.dateModel = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }